import { memo } from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';

function FundingOriginalAmountForm({ fundingAmount }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Original Amount:</Form.Label>
      </Col>
      <Col md={4} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="amount"
          id="amount"
          value={fundingAmount}
          readOnly
        />
      </Col>
    </>
  );
}

export default memo(FundingOriginalAmountForm);
